import { render, staticRenderFns } from "./dialogOrderDetail.vue?vue&type=template&id=1243abba&scoped=true"
import script from "./dialogOrderDetail.vue?vue&type=script&lang=js"
export * from "./dialogOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogOrderDetail.vue?vue&type=style&index=0&id=1243abba&prod&lang=scss&scoped=true"
import style1 from "./dialogOrderDetail.vue?vue&type=style&index=1&id=1243abba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243abba",
  null
  
)

export default component.exports